import {getTokenFromCookies} from '@/api/common-utils';
import {getSaUrl} from '@/api/gsc/utils';
import {routes} from '@/utils/const';
import {linkgraphDomain} from '@/utils/const';
import {getDomain} from '@/utils/url';

export function getAbsoluteLegacyUrl(path: string, withToken: boolean = true) {
  const token = getTokenFromCookies();
  const domainName = getDomain(linkgraphDomain);
  if (!withToken) {
    return `https://legacy.${domainName}/${path}`;
  }

  return `https://legacy.${domainName}/${path}?legacy_token=${token}`;
}

export function getHubSpotLink() {
  return `${getSaUrl()}/onboarding/`;
}
export function getRequestPricelink() {
  return `${getSaUrl()}/enterprise-quote/`;
}
export function getGrowBusinessLink() {
  return `${process.env.LINKGRAPH_COM}/learn-how-we-can-grow-your-business/`;
}
export function getKnowledgeAcademyLink() {
  return `${getSaUrl()}/academy/`;
}
export function getSearchAtlasKnowledgeAcademyLink() {
  return `${getSaUrl()}/academy/`;
}

export function getFullAccessLink() {
  return routes.pricing;
}

